import { App } from '../App';
import { formatNumberWithSuffix } from './formatNumberWithSuffix';

export function formatCurrency(number?: number, precision?: number): string {
  if (number === undefined) {
    return '';
  }

  const suffix = App.translate('common.currency');

  return formatNumberWithSuffix(number, suffix, precision);
}
